import { graphql } from "./graphql";

export const MeFragment = graphql(`
  fragment MeFragment on User @_unmask {
    id
    email
    fullName
    username
    avatarUrl
    updatedAt
    onboardedAt
    defaultOrganization {
      slug
    }
  }
`);

export const MeQuery = graphql(
  `
    query MeQuery {
      me {
        ...MeFragment
      }
      apiKeys {
        privateApiKey
      }
    }
  `,
  [MeFragment],
);

export const UsernameExistsQuery = graphql(`
  query UsernameExistsQuery($username: Slug!) {
    usernameExists(username: $username)
  }
`);

export const OrgFragment = graphql(`
  fragment OrgFragment on Organization @_unmask {
    id
    type
    slug
    name
    logoUrl
    updatedAt
    owner {
      id
    }
    permissions
  }
`);

export const OrganizationQuery = graphql(
  `
    query OrganizationQuery($orgSlug: Slug!) {
      organization(slug: $orgSlug) {
        ...OrgFragment
      }
    }
  `,
  [OrgFragment],
);
